import Constants from "../../components/constants";

function binaryToDecimal(binaryValue){
    return parseInt(binaryValue, 2);
}
function decimalToBinary(decimalValue, bitCount){
    //https://stackoverflow.com/questions/9939760/how-do-i-convert-an-integer-to-binary-in-javascript
    //!!! Negative values will be returned as two's complement !!!
    let value = decimalValue.toString(2);

    //Check if the value has a leading Minus (-)
    //if so, remove it
    //This prevents that after padding, there are values like 00-10010
    let appendMinus = false;
    if(value.indexOf(Constants.MINUS)>-1){
        appendMinus = true;
        value = value.substring(1, value.length);
    }

    while(bitCount>value.length){
        value = "0"+value;
    }

    //Re add the minus
    if(appendMinus){
        value = `${Constants.MINUS}${value}`;
    }
    return value;
}
function hexadecimalToDecimal(hexValue){
    return parseInt(hexValue, 16);
}
function decimalToHexadecimal(decimalValue){
    return decimalValue.toString(16);
}
function octalToDecimal(octalValue){
    return parseInt(octalValue, 8);
}
function decimalToOctal(decimalValue){
    return decimalValue.toString(8);
}

export {binaryToDecimal, decimalToBinary, hexadecimalToDecimal, decimalToHexadecimal, octalToDecimal, decimalToOctal}